'use strict';

/**
 * Created by jcrid01 on 10/2/15.
 */
module.exports = {
    componentDidMount: function componentDidMount() {
        if (this.listeners) {
            this.listeners().forEach(function (listener) {
                if (listener.onSuccess) {
                    listener.store.addChangeListener(listener.name + '_SUCCESS', listener.onSuccess);
                }
                if (listener.onFail) {
                    listener.store.addChangeListener(listener.name + '_FAILURE', listener.onFail);
                }
                if (listener.handler) {
                    listener.store.addChangeListener(listener.name, listener.handler);
                }
            });
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this.listeners) {
            this.listeners().forEach(function (listener) {
                if (listener.onSuccess) {
                    listener.store.removeChangeListener(listener.name + '_SUCCESS', listener.onSuccess);
                }
                if (listener.onFail) {
                    listener.store.removeChangeListener(listener.name + '_FAILURE', listener.onFail);
                }
                if (listener.handler) {
                    listener.store.removeChangeListener(listener.name, listener.handler);
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/mixins/ListenerMixin.js
// module id = 321
// module chunks = 0